import produce from 'immer';

export const setLoading = value =>
  produce(draft => {
    draft.loading = value;
  });
